import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import Img from "gatsby-image"
import tw, { styled, css } from "twin.macro"

import SlideSection from "../components/slideSectionWBG"
import NextPageButton from "../components/nextPageButton"
import ReactFullpage from "@fullpage/react-fullpage"
import { SlideProps } from "."

const Button = styled.button`
font-family: interstate; padding: 16px 25px; border-radius: 8px; font-size: 16px; line-height: 19.2px; background-color: #FFFFFF; font-weight: 700; color: #0063A6;
  ${tw`tracking-wide uppercase hidden md:inline hover:text-black focus:outline-none`}
`

const LogoSlide: React.SFC<SlideProps> = ({ 
  hideEnrolButton,
  enrolButtonClicked,
  nextButtonClicked, 
  isClient
}) => {
  // const data = useStaticQuery(query);

  // const logoSources = [
  //   data.squareLogo.childImageSharp.fixed,
  //   {
  //     ...data.landscapeLogo.childImageSharp.fixed,
  //     media: `(min-width: 768px)`,
  //   },
  // ]
  // const firstSquare = [
  //   data.firstSquare.childImageSharp.fixed,
  //   {
  //     ...data.firstSquare.childImageSharp.fixed,
  //     media: `(min-width: 768px)`,
  //   },
  // ]
  // const secondSquare = [
  //   data.secondSquare.childImageSharp.fixed,
  //   {
  //     ...data.secondSquare.childImageSharp.fixed,
  //     media: `(min-width: 768px)`,
  //   },
  // ]

  return (
    <SlideSection>
      <div data-top="opacity: 0; transform:scale(10)" data-center="opacity: 1; transform:scale(1)" data-bottom="opacity: 0; transform:scale(1)" data-anchor-target="#intro" css={[tw`flex flex-col justify-center items-center`]}>
        {isClient && 
        <text css={[
          `text-align:center; 
          z-index:2;
          @media (max-width: 768px) {
            padding: 4rem 2rem;
          }`
        ]}>
          <div css={[
              tw`mb-10`,
            ]}>
            <tspan css={[
              css`font-family:Interstate; font-weight: 700; font-size:60px; line-height: 55.8px; letter-spacing:-1px; margin-bottom: 32px;
              @media (max-width: 768px) {
                font-size:45px; 
                line-height: 47.8px;
              }`,
              tw`mb-16`,
            ]}>
              {"Get Trucking"}
            </tspan>
          </div>

          <div css={[
              tw`w-2/3 ml-auto mr-auto pb-10`,
            ]}>
              <tspan css={[
              'font-family:Interstate; font-size:16px;line-height:26px;letter-spacing:0.5px; font-weight: 300;',
              ]}>
                {"Start your career in Commercial Road Transport with a MITO Micro®"}
              </tspan>
          </div>

          <ReactFullpage.Wrapper>
            <Button
              css={[
                tw`transition-opacity duration-500 hidden md:inline`,
              ]}
              onClick={enrolButtonClicked}
            >
              Enrol for free
            </Button>
          </ReactFullpage.Wrapper>
        </text>
        }
        <div css={[tw`absolute bottom-0 mb-16`]}>
          <NextPageButton onClick={nextButtonClicked} label="Go" />
        </div>
      </div>
    </SlideSection>
  )
};
export default LogoSlide
